<template>
  <div>
    <div class="van-contact-edit" data-v-629481ba="">
      <div class="van-contact-edit__fields">
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>姓名</span></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <input
                v-model="userInfo.name"
                class="van-field__control"
                placeholder="请填写姓名"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>电话</span></div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <input
                v-model="userInfo.mobile"
                class="van-field__control"
                placeholder="请填写电话"
                type="tel"
              />
            </div>
          </div>
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label">
            <span>身份证</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">
              <input
                  v-model="userInfo.cardId"
                  class="van-field__control"
                  placeholder="请填写身份证"
                  type="tel"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="van-contact-edit__buttons">
        <button
            class="
            van-button
            van-button--danger
            van-button--normal
            van-button--block
            van-button--round
          "
            @click="onSave"
        >
          <div class="van-button__content">
            <span class="van-button__text">保存</span>
          </div>
        </button
        >
        <button
            class="
            van-button
            van-button--default
            van-button--normal
            van-button--block
            van-button--round
          "
            @click="onDelete"
        >
          <div class="van-button__content">
            <span class="van-button__text">删除</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import {addIdentity, deleteIdentity, modifyIdentity,} from "@/api/user";

export default {
  name: "info-edit",
  data() {
    return {
      identityId: "",
      userInfo: {
        name: "",
        mobile: "",
        cardId: "",
      },
    };
  },
  created() {
    this.identityId = this.$route.query.identityId;
    if (this.identityId > 0) {
      let info = JSON.parse(sessionStorage.getItem("info"));
      this.userInfo = {
        identityId: info.identityId,
        name: info.name,
        mobile: info.mobile,
        cardId: info.cardId,
      };
    }
  },
  methods: {
    async onSave() {
      let params = {
        name: this.userInfo.name,
        mobile: this.userInfo.mobile,
        cardId: this.userInfo.cardId,
      };
      this.identityId && (params.identityId = this.identityId);
      let res = await (this.identityId
          ? modifyIdentity(params)
          : addIdentity(params));
      if (res.code === 0) {
        Toast.success((this.identityId ? "编辑" : "新增") + "成功");
        this.$router.go(-1);
      }
    },
    onDelete() {
      deleteIdentity(this.identityId).then((res) => {
        Toast({message: "删除成功"});
        this.$router.go(-1);
      });
    },
  },
};
</script>

<style scoped>
</style>
